export function navInit() {

    $(document).scroll(function() {
        // console.log($(document).scrollTop());

        if (!$('.navbar').hasClass('opaque')) {
            if ($(document).scrollTop() >= 200) {
                $('.navbar').addClass('opaque-black');
            } else {
                $('.navbar').removeClass('opaque-black');
            }
        }
    });

    $('.navbar-toggler').on('click', function() {
        // $('body').toggleClass('no-scroll');
        $('#navbarSupportedContent').toggleClass('show');
    });

}